import client from '../httpClient';

const librarydirGetDirectlyTreeApi = (id = 0) => {
  return client.get(`library-directories/tree/${id}`);
};

export default librarydirGetDirectlyTreeApi;
